import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LoginComponent } from './login/login.component';
import { AuthGuard } from './_helpers';

const routes: Routes = [
  {
    path: 'login',
    component: LoginComponent
  },
  {
    path: 'repatriacionWeb',
    loadChildren: () => import('./consultarepatriacionweb/consultarepatriacionweb.module').then(mod => mod.ConsultaRepatriacionWebModule)
  },
  {
    path: 'repatriacionWeb1',
    //loadChildren: () => import('./consultarepatriacionweb/consultarepatriacionweb.module').then(mod => mod.ConsultaRepatriacionWebModule)
     loadChildren: () => import('./repatriacionweb/repatriacionweb.module').then(mod => mod.RepatriacionWebModule)
  },
  {
    path: 'solicitudRepatriacion',
    loadChildren: () => import('./solicitudrepatriacion/solicitudrepatriacion.module').then(mod => mod.SolicitudRepatriacionModule)
  },
  {
    path: 'DAI', 
    loadChildren: () => import('./home/home.module').then(mod => mod.HomeModule),
    canActivate: [AuthGuard]
  },
  {
    path: '**', pathMatch: 'full', redirectTo: 'DAI'
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
